import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
        MainWrapper:{
            paddingRight:'0.625rem',
            position:'relative',
            height:'calc(100% - 145px)',
            overflowY:'auto'
        }
}));